import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfterSection() {
  return <section aria-labelledby="compare-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-55" data-mp="1xotspxz95xp4">
      <div className="mx-auto max-w-5xl" data-id="element-56" data-mp="22nohdgjwigh5">
        <SectionHeading id="compare-heading" title={<>
              Less Time Organizing. <Accent data-id="element-58" data-mp="1sqjvlhtywn0v">More Time Teaching.</Accent>
            </>} data-id="element-57" data-mp="22qsrsvnym8g9" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-59" data-mp="1ezdnwygjbj2w">
          <div className="rounded-[20px] bg-brand-ivory/70 p-7 sm:p-9" data-id="element-60" data-mp="1f0yiup6rh41a">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-charcoal/55" data-id="element-61" data-mp="1jxozbdmha1n8">Before</h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-62" data-mp="152ipefk9hiom">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/60" data-id="element-63" data-mp="19zsokmxgd8pn">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-[#B5655E]" strokeWidth={2.25} aria-hidden="true" data-id="element-64" data-mp="275vsowf2unbp" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[20px] border-2 border-brand-cta/40 bg-white p-7 shadow-[0_30px_60px_-40px_rgba(30,82,54,0.55)] sm:p-9" data-id="element-65" data-mp="2g6amkk63xaqt">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-cta" data-id="element-66" data-mp="1ogpcbg1ra7t2">
              With Lash &amp; Brow Instructor Ready™
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-67" data-mp="1x9izdzng2bhh">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-68" data-mp="1siu7wkbrleic">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-69" data-mp="14sgd4m1sp1k2" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}